import { Exclude, Expose } from 'class-transformer'

@Exclude()
export class PenNameOptionType {
  @Expose({ name: 'id' })
  value: number

  @Expose({ name: 'firstPenName' }) label: string

  @Expose()
  totalBook: number
}
